import "./Styles/App.css";
import "./i18n";
import { Outlet } from "react-router-dom";
import Header from "./Components/Header";
import { Container } from "@mui/material";
import Footer from "./Components/Footer";

const App: React.FC = () => {
  return (
    <div className="App backgroundImage">         
      <Header />
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          marginTop: "0.8em",
          marginBottom: "6vw"
        }}
      >
        <Outlet />
      </Container>
      <Footer />      
    </div>
  );
}

export default App;
